import ProductsHero from '@/components/Products/ProductsHero';
import ProductList from '@/components/Products/ProductList';

export default function Product() {
  return (
    <main>
      <ProductsHero />
      <ProductList />
    </main>
  );
}
